import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'app/components';
import { Question } from '@phosphor-icons/react'
import { Tooltip } from 'app/components';

const MeetingDetails = (props) => {
  const { 
    setFormData, 
    formData, 
    error, 
    setError,
  } = props

  const handleChange = (field) => (e) => {
    const value = e.target.value;

    setFormData({ 
      ...formData, 
      [field]: value, 
    });

    if (field === 'meeting_link' && value === '') {
      setError((prev) => ({ 
        ...prev, 
        meeting_linkError: 'This field is required', 
      }));
    } else if (field === 'meeting_link') {
      setError((prev) => ({ 
        ...prev, 
        meeting_linkError: '', 
      }));
    }
  };  

  return (
    <>
      <div className="flex flex-col gap-2 items-start justify-between self-stretch">
        <label className={`label-16 ${error.meeting_linkError ? 'text-error' : 'text-grey-70'}`}>
          Event link   <Tooltip className="text-center" content="This is editable upto 2 hours before the event time">
            <p className="inline-block">
              <Question className="inline-block" size={20} />
            </p>
          </Tooltip>
        </label>
        <Input
          value={formData.meeting_link}
          width="100%"
          validationStatus={error.meeting_linkError && 'error'}
          helpText={error.meeting_linkError}
          onChange={handleChange('meeting_link')}
        />
      </div>
      <div className="flex items-start justify-between gap-5 self-stretch">
        <div className="w-full flex flex-col gap-2">
          <label className="label-16 text-grey-70">Meeting ID (Optional)</label>
          <Input width="100%"
            value={formData.meeting_id}
            onChange={handleChange('meeting_id')} />
        </div>
        <div className="w-full flex flex-col gap-2">
          <label className="label-16 text-grey-70">Password (Optional)</label>
          <Input width="100%"
            value={formData.meeting_password}
            onChange={handleChange('meeting_password')} />
        </div>
      </div>
    </>
  )
}

MeetingDetails.propTypes = {
  setFormData: PropTypes.func,
  formData: PropTypes.object,
  error: PropTypes.object,
  setError: PropTypes.func,
};

MeetingDetails.defaultProps = {
  setFormData: () => {},
  formData: {},
  error: {},
  setError: () => {},
};

export default MeetingDetails;
